// Angular imports
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class PortfolioHelperService {
    private readonly _subjectLoading = new Subject<boolean>();

    onLoadingEvent(): Subject<boolean> {
        return this._subjectLoading;
    }
    showLoading(): void {
        this._subjectLoading.next(true);
    }
    hideLoading(): void {
        this._subjectLoading.next(false);
    }
}
